import { Button, Dropdown, MenuProps } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { MoreOutlined } from "@ant-design/icons";
import { SchedFunctionType } from "src/businessServices/services/bsScheduling/SchedulingTypes";
import { ItemType } from "antd/es/menu/hooks/useItems";
import { DeleteButton } from "./DeleteButton";
import { SchedulingControlStore } from "../../../SchedulingControlStore";
import styles from "./SchedActions.module.less";

interface PropsSchedActions {
  store: SchedulingControlStore;
}

export const SchedActions: React.FC<PropsSchedActions> = observer(
  ({ store }) => {
    const { operationLoading, data, availableFunctions } = store;
    const disabled = data.status !== "ready" || operationLoading;
    const actionsMap: Record<SchedFunctionType, ItemType> = {
      [SchedFunctionType.allowTaskDeletion]: {
        key: "delete",
        label: <DeleteButton store={store} />,
      },
    };
    const menuItems = Object.entries(actionsMap)
      .filter(([key]) => availableFunctions.has(key as SchedFunctionType))
      .map(([_key, item]) => [item, { type: "divider" } as ItemType])
      .flat();
    menuItems.pop();
    if (!menuItems.length) return null;
    const menuProps: MenuProps = { items: menuItems };
    return (
      <Dropdown menu={menuProps} placement="bottomRight" disabled={disabled}>
        <Button icon={<MoreOutlined />} className={styles.button} />
      </Dropdown>
    );
  },
);
